import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { OverlayTrigger, Form, Popover, Button, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";

import classnames from "classnames";
import { format } from "date-fns";
import Icon from "@mdi/react";
import { mdiCheckCircleOutline, mdiChevronRight, mdiLoading, mdiFilter } from "@mdi/js";
import * as NotificationAction from "../../../reducers/notificationReducer";
import * as adminPartnerListAction from "../../../reducers/Admin/adminPartnershipListReducer";
import * as eventAction from "../../../reducers/eventReducer";
import "./AdminPartnerShipsList.scss";

import Loading from "../../../appComponents/Loading";
import FilterByInput from "../../../components/FilterByInput";
import Helpers, { downloadPdf, isDateCorrectFormat } from "../../../utils/helpers";

import {
  filterInputEndDate,
  filterInputStartDate,
} from "../../../components/FilterByInput/constant";
import { maxPendingRequestMsg, maxPendingRequest, monthsWhenNoFilterForDonation, monthsWhenNoFilterForDonationMsg, monthsWhenCampaignSpecifiedForDonationMsg, monthsWhenNonprofitOrProjectSpecifiedForDonationMsg, monthsWhenCampaignSpecifiedForDonation, monthsWhenNonprofitOrProjectSpecifiedForDonation } from "../../../config";
import { checkMonths } from "../../../utils/helpers";
class AdminPartnerShipsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewDetails: "",
      eventList: [],
      query: {},
      currentTab: "export",
      filters: [
        {
          label: "Search",
          type: [
            {
              type: "default",
              label: "Name",
              query: "q",
            },
            {
              type: "email",
              label: "Email id",
              query: "filter_by_user_email",
            },
            {
              type: "phone",
              label: "Mobile number",
              query: "filter_by_user_phone",
            },
            {
              type: "order",
              label: "Order Id",
              query: "filter_by_order_id",
            },
            {
              type: "disbursement",
              label: "Disbursement Id",
              query: "filter_by_disbursement_number",
            },
          ],
          placeholder: "Search for Name, Email, Phone, Order id, Disbursement id",
        },
        { ...filterInputStartDate("after") },
        { ...filterInputEndDate("before") },
        // {
        //   label: "Created before",
        //   type: "date",
        //   query: "before",
        // },
        {
          label: "Status",
          type: "list",
          query: "filter_by_status",
          list: [
            { label: "Pending", value: "PENDING" },
            { label: "Amount Confirmed", value: "AMOUNTCONFIRMED" },
            { label: "User Confirmed", value: "USERCONFIRMED" },
            { label: "Confirmed", value: "CONFIRMED" },
            { label: "Disbursed", value: "DISBURSED" },
            { label: "Settled", value: "SETTLED" },
            { label: "Failed", value: "FAILED" },
            { label: "Refunded", value: "REFUNDED" },
          ],
          filterType: "multiple",
        },
        {
          label: "Nonprofit",
          type: "service",
          query: "filter_by_nonprofit",
          placeholder: "Type nonprofit name",
          service: "nonprofits",
        },
        // {
        //   label: "Project",
        //   type: "service",
        //   query: "filter_by_project",
        //   placeholder: "Type project name",
        //   service: "projects",
        // },
        {
          label: "Fundraiser",
          type: "service",
          query: "filter_by_campaign",
          placeholder: "Type fundraiser title",
          service: "campaigns",
        },
        // {
        //   label: "Event",
        //   type: "list",
        //   query: "filter_by_event",
        // },
        // {
        //   label: "Settlement Id",
        //   type: "text",
        //   query: "filter_by_payout_id",
        //   placeholder: "Enter Settlement ID or press Enter",
        //   allowed: "",
        // },
        // {
        //   label: "Entity::Gateway",
        //   type: "custom",
        // },
      ],
      exportFilters: [],
      reportLinks: [],
      loader: false,
    };
  }

  componentDidMount() {
    const { partnership, Partnership, event, Event } = this.props;
    if (!partnership.get_status.partnership) {
      Partnership.getPartnership();
    }

    if (!event.get_status.event) {
      Event.get().then((events) => {
        events &&
          events.length > 0 &&
          this.setState({
            eventList: events.map((event) => {
              return [
                {
                  label: event.name,
                  value: event.event_id,
                },
              ];
            }),
          });
      });
    }
  }

  componentDidUpdate() {
    let updatedFilters = this.state.filters;
    if (this.state.eventList.length > 0) {
      for (let e = 0; e < updatedFilters.length; e++) {
        if (updatedFilters[e].label === "Event") {
          updatedFilters[e].list = this.state.eventList.map((list) => {
            return list[0];
          });
        }
      }
      // if (this.state.filters.filter((filter) => filter.label === "Event")[0].list.length === 0) {
      //   this.setState({
      //     filters: updatedFilters,
      //   });
      // }
    }
  }
  componentWillUnmount() {
    const { Partnership } = this.props;
    Partnership.reset();
  }

  loadMore = () => {
    const { Partnership } = this.props;
    const { query } = this.state;
    Partnership.getPartnership(query);
  };

  refreshPartnershipList = () => {
    const { Partnership } = this.props;
    const { query } = this.state;
    Partnership.reset();
    Partnership.getPartnership(query);
  };

  filterOnChange = (filters) => {
    this.setState({ filters, query: Helpers.queryBuilderForFilterInput(filters) }, () => {
      this.refreshPartnershipList();
    });
  };
  fitersForExport = (filter) => {
    const { exportFilters } = this.state;
    if (!exportFilters.includes(filter))
      this.setState({ exportFilters: [...exportFilters, filter] });
    else
      this.setState({
        exportFilters: exportFilters.filter((exportFilters) => exportFilters !== filter),
      });
  };
  addToFilter = (type, value) => {
    const { filters } = this.state;
    const newOption = { ...filters.find((i) => i.label === type) };
    newOption.data = value;
    const newOptions = filters.map((item) => (item.label === type ? newOption : item));
    this.setState(
      { filters: newOptions, query: Helpers.queryBuilderForFilterInput(newOptions) },
      () => {
        this.refreshPartnershipList();
      }
    );
  };

  showDetailsClick = (id) => {
    const { viewDetails } = this.state;
    if (id === viewDetails) {
      this.setState({ viewDetails: "" });
    } else {
      this.setState({ viewDetails: id });
    }
  };

  addToFilterHTML = (type, value) => (
    <span className="filter-wrapper">
      <button
        type="button"
        className="btn btn-rounded btn-inverse-outline-primary btn-filters"
        onClick={(e) => {
          e.preventDefault();
          this.addToFilter(type, value);
        }}
      >
        <Icon path={mdiFilter} size={0.5} color="#2196f3" />
        <span>Apply as filter</span>
      </button>
    </span>
  );

  onTabChange = (e, tab) => {
    this.setState({
      currentTab: tab,
    });
    if (tab === "downloads") {
      this.getReportLinks(e, "downloads");
    }
  };

  popover = () => {
    const {  partnership } = this.props;
    const { reportLinks } = this.state;
    const fieldNames = {
      basic:
        "(Date, Time, Order Id,Transaction Reference,Source, Status, Campaign ID, Campaign Name, Donation Currency, Donation Amount, Donor ID, Donor Name, Donor Email, Donor Mobile Number, Donor City, Donor State, Donor Country)",
      nonprofit: "(ID, Name, URL)",
      receipt: "(URL)",
    };
    return (
      <Popover id="popover-basic-1">
        <Popover.Content>
          <Row>
            <Col md={12} xs={12} className="export-download">
              <ul className="nav nav-tabs tab-basic" role="tablist">
                <li className="nav-item">
                  <a
                    className={`${`nav-link ${
                      this.state.currentTab === "export" ? `active` : ""
                    } show`}`}
                    id="export-tab"
                    data-toggle="tab"
                    href="#export"
                    onClick={(e) => this.onTabChange(e, "export")}
                  >
                    Export
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`${`nav-link ${
                      this.state.currentTab === "downloads" ? `active` : ""
                    } show`}`}
                    id="download-tab"
                    data-toggle="tab"
                    href="#download"
                    onClick={(e) => this.onTabChange(e, "downloads")}
                  >
                    Downloads
                  </a>
                </li>
              </ul>
              <div className="tab-content tab-content-basic">
                {this.state.currentTab === "export" ? (
                  <div className="tab-pane fade show active">
                    <Col md={12} xs={12} className="export-filters">
                      <Popover.Title as="h3">Select Fields</Popover.Title>
                      <Form.Check
                        className="popover-checkbox"
                        type="checkbox"
                        id="basic"
                        label="Basic Details"
                        disabled
                        checked
                      />
                      <div className="popover-checkbox-div" htmlFor="basic">
                        {fieldNames.basic}
                      </div>
                      <Form.Check
                        className="popover-checkbox"
                        type="checkbox"
                        id="nonprofit"
                        label="Nonprofit"
                        onClick={() => this.fitersForExport("nonprofit")}
                      />
                      <div className="popover-checkbox-div" htmlFor="nonprofit">
                        {fieldNames.nonprofit}
                      </div>
                      <Form.Check
                        className="popover-checkbox"
                        type="checkbox"
                        id="receipt"
                        label="Receipt"
                        onClick={() => this.fitersForExport("receipt")}
                      />
                      <div className="popover-checkbox-div" htmlFor="receipt">
                        {fieldNames.receipt}
                      </div>
                      <div className="text-center">
                        <Button className="btn btn-sm" onClick={this.generateReportLink}>{partnership.get_status.generate_report === '' ? 'Export to CSV' : partnership.get_status.generate_report === 'pending' ? 'Generating...' : 'Export to CSV'}</Button>
                      </div>
                    </Col>
                  </div>
                ) : (
                  <div className="tab-pane fade show active">
                    <Col md={12} xs={12}>
                      <Popover.Title as="h3">
                        <span>Queued for download</span>
                        <button
                          type="button"
                          className="btn btn-inverse-link"
                          onClick={this.getReportLinks}
                        >
                          <div className="export">
                            <div
                              className={`${
                                this.state.loader ? `export-loader-spin` : `export-loader`
                              }`}
                            ></div>
                          </div>
                        </button>
                      </Popover.Title>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Requested</th>
                            <th>Tags</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(!reportLinks || reportLinks.length === 0) && (
                            <i className="align-center">No items available</i>
                          )}
                          {reportLinks &&
                            reportLinks.map((link, index) => {
                              let filterAppl = link?.queryParameter?.filter;
                              return (
                                <tr key={index}>
                                  <td style={{ maxWidth: "100%", whiteSpace: "nowrap" }}>
                                    <div className="download-tag-wrapper">
                                      <span className="download-tag">
                                        {format(new Date(link.created_at), "MMM do, yyyy HH:mm aa")}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="download-tag-wrapper">
                                      {["a"]?.map((item) => (
                                        <>
                                          {filterAppl && (
                                            <>
                                              {filterAppl?.endDate ? (
                                                <span className="download-tag">
                                                  Created before:{" "}
                                                  {format(
                                                    new Date(filterAppl?.endDate),
                                                    "MMM do, yyyy"
                                                  )}
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                              {filterAppl?.startDate ? (
                                                <span className="download-tag">
                                                  Created after:{" "}
                                                  {format(
                                                    new Date(filterAppl?.startDate),
                                                    "MMM do, yyyy"
                                                  )}
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                              {/* {filterAppl.gateway?.length ? (
                                                <span className="download-tag">
                                                  Gateway: {filterAppl?.gateway}
                                                </span>
                                              ) : null}
                                              {filterAppl.payment_entity.length ? (
                                                <span className="download-tag">
                                                  Payment Entity: {filterAppl.payment_entity}
                                                </span>
                                              ) : null}
                                              {filterAppl.settlementId.length ? (
                                                <span className="download-tag">
                                                  Settlement Id{filterAppl.settlementId}
                                                </span>
                                              ) : null}
                                              {filterAppl.projects.length ? (
                                                <span className="download-tag">
                                                  Project: {filterAppl.projects}
                                                </span>
                                              ) : null} */}
                                              {filterAppl.nonprofits.length ? (
                                                <span className="download-tag">
                                                  Nonprofit: {filterAppl.nonprofits}
                                                </span>
                                              ) : null}
                                              {filterAppl.campaigns.length ? (
                                                <span className="download-tag">
                                                  Fundraiser: {filterAppl.campaigns}
                                                </span>
                                              ) : null}
                                              {/* {filterAppl.tag ? (
                                                <span className="download-tag">
                                                  Event: {filterAppl.tag}
                                                </span>
                                              ) : (
                                                ""
                                              )} */}
                                              {filterAppl.status.length ? (
                                                <span className="download-tag">
                                                  Status: {filterAppl.status}
                                                </span>
                                              ) : null}
                                            </>
                                          )}
                                        </>
                                      ))}
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      className={`btn btn-xs ${
                                        link.status === "completed"
                                          ? "btn-success"
                                          : "disabled btn-secondary"
                                      }`}
                                      href={link?.dataLink||""}
                                      download={`GiveFundraisers-live-${format(
                                        new Date(),
                                        "HH:mm:ss"
                                      )}`}
                                    >
                                      {link.status === "completed" ? "Download" : link.status}
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    
                    </Col>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row></Row>
        </Popover.Content>
      </Popover>
    );
  };

  generateReportLink = (e) => {
    e.preventDefault();
    this.setState({ loader: true });
    const { Partnership, Notification } = this.props;
    const { query, exportFilters, reportLinks } = this.state;
    const months = checkMonths(query.after, query.before);
    const pendingCount = reportLinks?.filter(donation => donation.status === "pending").length;

    if (pendingCount >= maxPendingRequest) {
        Notification.addNotification(maxPendingRequestMsg);
        this.setState({ loader: false });
        return;
    }

    if (!query?.filter_by_campaign?.length  && !query?.filter_by_nonprofit?.length && !query?.filter_by_project?.length && months > monthsWhenNoFilterForDonation) {
        Notification.addNotification(monthsWhenNoFilterForDonationMsg);
        this.setState({ loader: false });
        return;
    }

    if (query?.filter_by_campaign?.length && months > monthsWhenCampaignSpecifiedForDonation) {
      Notification.addNotification(monthsWhenCampaignSpecifiedForDonationMsg);
      this.setState({ loader: false });
      return;
      }

      if ((query?.filter_by_nonprofit?.length || query?.filter_by_project?.length) && !query?.filter_by_campaign?.length && months > monthsWhenNonprofitOrProjectSpecifiedForDonation) {
        Notification.addNotification(monthsWhenNonprofitOrProjectSpecifiedForDonationMsg);
        this.setState({ loader: false });
        return;
    }

    Partnership.generateReportLink({ ...query }, exportFilters)?.then((data) => {
      if (data !== undefined) {
        Partnership.getReportLinks().then((reportsData) => {
          this.setState({ reportLinks: reportsData, currentTab: "downloads", loader: false });
        });
      } else {
        this.setState({ currentTab: "export", loader: false });
      }
    });
  };

  getReportLinks = (e, isExport) => {
    e.preventDefault();
    const { Partnership } = this.props;
    this.setState({
      loader: true,
    });
    if (isExport) {
      this.setState({
        currentTab: isExport,
      });
    }
    Partnership.getReportLinks().then((data) => {
      setTimeout(() => {
        this.setState({
          loader: false,
        });
      }, 2000);
      this.setState({ reportLinks: data });
    });
  };

  reSyncPartnership = (order_id) => {
    const { Partnership } = this.props;
    Partnership.getReSyncPatnership(order_id);
  };

  partnershipHTML = () => {
    const { partnership = {} } = this.props;
    const { partnershipData = [], get_status = {} } = partnership;
    const { viewDetails } = this.state;
    if (
      !get_status?.partnership ||
      (get_status?.partnership === "pending" && partnershipData?.length === 0)
    ) {
      return <Loading />;
    }
    if (partnershipData?.length === 0) {
      return <i className="align-center">No items available</i>;
    }
    return partnershipData?.map((item) => {
      return (
        <li className="table-list-item" key={item.order_id}>
          <div className="row">
            <div className="col-md-12 table-col">
              <div className="row">
                <div className="col-md-1 col-12 table-col dl-mob">
                  {item?.created_at ? (
                    <>
                      <small style={{ display: "block" }}>
                        {format(new Date(item?.created_at), "do MMM yyyy")}
                      </small>
                      <small style={{ display: "block" }}>
                        {format(new Date(item?.created_at), "HH:mm")}
                      </small>
                    </>
                  ) : null}
                </div>
                {item.user ? (
                  <div className="col-md-3 col-12 table-col dl-mob user-info-livedis">
                    <div className="name-email">
                      <span>{item.user.name}</span>
                      <small>
                        {item.user.email}
                        {item.user.is_email_verified ? (
                          <Icon path={mdiCheckCircleOutline} size={0.75} color="#777777" />
                        ) : null}
                      </small>
                    </div>
                  </div>
                ) : (
                  <div className="col-md-3 col-12 table-col dl-mob user-info-livedis">
                    User Not Available
                  </div>
                )}
                <div className="col-md-4 col-12 table-col dl-mob">
                  {item.nonprofit ? (
                    <div className="row">
                      <div className="col-md-12">
                        <strong>(N) </strong>{" "}
                        <a target="_blank" href={item.nonprofit.permalink}>
                          {item.nonprofit.name}
                        </a>
                        {this.addToFilterHTML("Nonprofit", [
                          {
                            title: `Nonprofit: ${item.nonprofit.name}`,
                            data: { filter_by_nonprofit: item.nonprofit._id },
                          },
                        ])}
                      </div>
                      {item.project ? (
                        <div className="col-md-12">
                          <strong>(P) </strong>{" "}
                          <a target="_blank" href={item.project.permalink}>
                            {item.project.name}
                          </a>
                          {this.addToFilterHTML("Project", [
                            {
                              title: `Project: ${item.project.name}`,
                              data: { filter_by_project: item.project._id },
                            },
                          ])}
                        </div>
                      ) : null}
                      {item.campaign ? (
                        <div className="col-md-12">
                          <strong>(C) </strong>{" "}
                          <a target="_blank" href={item.campaign.permalink}>
                            {item.campaign.title}
                          </a>
                          {this.addToFilterHTML("Fundraiser", [
                            {
                              title: `Fundraiser: ${item.campaign.title}`,
                              data: { filter_by_campaign: item.campaign._id },
                            },
                          ])}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-1 col-12 table-col dl-mob">
                  <div>
                    {item.currency_code}&nbsp;{item.amount}
                  </div>
                  <div>
                    <small>
                      {item.retention_percent !== undefined
                        ? `Retention %: ${item.retention_percent}`
                        : null}
                    </small>
                  </div>
                 
                </div>
                <div className="col-md-2 col-12 table-col dl-mob user-info-livedis">
                  <div
                    className={classnames(
                      "badge badge-pill ellipsis",
                      { "badge-warning": item.status === "USERCONFIRMED" },
                      { "badge-dark": item.status === "AMOUNTCONFIRMED" },
                      { "badge-success": item.status === "CONFIRMED" },
                      { "badge-info": item.status === "DISBURSED" || item.status === "SETTLED" },
                      { "badge-danger": item.status === "FAILED" || item.status === "REFUNDED" },
                      { "badge-primary": item.status === "PENDING" || item.status === "PENDING" }
                    )}
                  >
                    {item.status}
                  </div>
                  {this.addToFilterHTML("Status", [
                    { title: `Status: ${item.status}`, data: { filter_by_status: item.status } },
                  ])}
                </div>
                <div className="col-md-1 col-12 table-col dl-mob-right">
                  {viewDetails === item.order_id ? (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.showDetailsClick(item.order_id);
                      }}
                    >
                      Hide Details
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.showDetailsClick(item.order_id);
                      }}
                    >
                      View Details
                    </button>
                  )}
                </div>
              </div>
            </div>
            {viewDetails === item.order_id ? (
              <div className="col-md-12 disbursement-view-details">
                <div className="ibox float-e-margins">
                  <div className="ibox-content ibox-heading">
                    <div className="row">
                      <div className="col-md-12">
                        <h6 className="left">Other details</h6>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-4 bold">Order Id :</div>
                          <div className="col-md-8 dl-mob">{item.order_id}</div>
                          <div className="col-md-4 bold">Preferred Tax Exemption :</div>
                          <div className="col-md-8 dl-mob">
                            {item.user && item.user.preferred_tax_exemption ? (
                              <span>{item.user.preferred_tax_exemption}</span>
                            ) : (
                              "NA"
                            )}
                          </div>
                          <div className="col-md-4 bold">Campaign Name:</div>
                          <div className="col-md-8 dl-mob">{item?.campaign?.name}</div>
                          <div className="col-md-4 bold">Campaign Program:</div>
                          <div className="col-md-8 dl-mob">{item?.campaign?.program}</div>
                          <div className="col-md-4 bold">Source Legal Name:</div>
                          <div className="col-md-8 dl-mob">{item?.source?.legal_name}</div>
                          <div className="col-md-4 bold">Mobile No:</div>
                          <div className="col-md-8 dl-mob">
                            {item.user && item.user.phone ? (
                              <span>
                                {item.user.phone}{" "}
                                {item.user.is_phone_verified ? (
                                  <Icon path={mdiCheckCircleOutline} size={0.75} color="#777777" />
                                ) : null}
                              </span>
                            ) : (
                              "NA"
                            )}
                          </div>
                          <div className="col-md-4 bold">Email:</div>
                          <div className="col-md-8 dl-mob">
                            {item.user && item.user.email ? <span>{item.user.email}</span> : "NA"}
                          </div>

                          <div className="col-md-4 bold">Address:</div>
                          <div className="col-md-8">
                            {item.user && item.user.address ? item.user.address.formatted : "NA"}
                          </div>

                          <div className="col-md-4 bold">Receipt:</div>
                          {item.receipt_uri ? (
                            <div className="col-md-8">
                              <div
                                onClick={() => {
                                  downloadPdf(item.receipt_uri);
                                }}
                                className="download-title"
                              >
                                Download
                              </div>
                            </div>
                          ) : (
                            <div className="col-md-8">{item.receipt_reason}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-4 bold">Settlement date:</div>
                          <div className="col-md-8 dl-mob">
                            {item.settlement_date ? (
                              <span>{format(new Date(item.settlement_date), "do MMM yyyy")} </span>
                            ) : (
                              "NA"
                            )}
                          </div>
                          <div className="col-md-4 bold">Payment Method:</div>
                          <div className="col-md-8 dl-mob">
                            {item?.payment_method ? <span>{item.payment_method} </span> : "NA"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {item.additional_fields && Object.keys(item.additional_fields).length > 0
                        ? Object.keys(item.additional_fields).map((key, index) => (
                            <div className="col-md-12" key={index}>
                              <div className="row">
                                <div className="col-md-2">{Helpers.snakeCaseToString(key)} :</div>
                                <div className="col-md-10">
                                  {item.additional_fields[key] != null &&
                                  typeof item.additional_fields[key] === "object" ? (
                                    <div className="row">
                                      <div className="col-md-2 pd-l-0">
                                        {Object.keys(item.additional_fields[key]).map(
                                          (keyPair, index) => (
                                            <div key={index}>{keyPair}</div>
                                          )
                                        )}
                                      </div>
                                      <div className="col-md-10 word-break">
                                        {Object.values(item.additional_fields[key]).map(
                                          (valuePair, index) => {
                                            if (typeof valuePair !== "object") {
                                              return <div key={index}> - {valuePair}</div>;
                                            } else {
                                              try {
                                                Object.values(valuePair).map((item, index) => {
                                                  return <div key={index}> - {item}</div>;
                                                });
                                              } catch (e) {
                                                // Do Nothing.
                                                // Unable to get additional field values
                                              }
                                            }
                                          }
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="row">
                                      <div className="col-md-12 pd-l-0">
                                        {item.additional_fields[key]}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </li>
      );
    });
  };

  render() {
    const { partnership = {} } = this.props;
    const { filters } = this.state;
    const { partnershipData = [], get_status = {}, load_status = {} } = partnership;
    return (
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h3 className="mr-b-20">All Partnerships</h3>
                <FilterByInput value={filters} onChange={this.filterOnChange} />
                <div className="row justify-content-end">
                  <div className="col-md-12 col-12 text-right">
                    <OverlayTrigger
                      trigger="click"
                      placement={isMobile ? "bottom-end" : "left-start"}
                      overlay={this.popover()}
                      rootClose
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={(e) => this.getReportLinks(e, "export")}
                      >
                        Proceed to Export
                      </button>
                    </OverlayTrigger>
                    <div>
                      <i>
                        <small className="text-muted">CSV file contains max of 1000 entries</small>
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="card-col col-xl-12 col-12">
                <div className="ibox-content">
                  <div className="table-list live-dis-table">
                    <ul>
                      <li className="table-head">
                        <div className="row">
                          <div className="col-md-12 table-col">
                            <div className="row">
                              <div className="col-md-1 table-col dl-mob">Date</div>
                              <div className="col-md-3 table-col dl-mob">Donor</div>
                              <div className="col-md-4 table-col dl-mob">
                                Project(P) / Fundraiser(F)
                              </div>
                              <div className="col-md-1 table-col dl-mob">Amount</div>
                              <div className="col-md-2 table-col dl-mob">Status</div>
                              <div className="col-md-1 table-col dl-mob-right">Details</div>
                            </div>
                          </div>
                        </div>
                      </li>
                      {partnershipData?.length > 0 && this.partnershipHTML()}
                    </ul>
                    <div className="row">
                      {load_status.partnership && partnershipData.length>=10? (
                        <div className="col-md-12 text-center">
                          <button
                            type="button"
                            className="btn btn-fw align-center"
                            onClick={(e) => {
                              e.preventDefault();
                              this.loadMore();
                            }}
                          >
                            Load more
                          </button>
                        </div>
                      ) : null}
                      {get_status.partnership === "pending" && partnershipData.length !== 0 ? (
                        <div className="col-md-12">
                          <Loading />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    partnership: state.adminPartnershipList,
    event: state.event,
  };
};

const mapActionToProps = (dispatch) => ({
  Partnership: bindActionCreators(adminPartnerListAction, dispatch),
  Event: bindActionCreators(eventAction, dispatch),
  Notification: bindActionCreators(NotificationAction, dispatch)
});

export default connect(mapStateToProps, mapActionToProps)(AdminPartnerShipsList);
